import * as React from "react";
const SvgPulse = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871V22.13H22.13V1.87H12ZM3.38 3.38H20.62V20.62H3.38V12Zm6.818 3.336-.029.049-1.416 2.265-1.385 2.217-.967.002-.966.004v1.496l1.384-.002 1.385-.002.922-1.476c.507-.812.923-1.475.926-1.475.002 0 .847 1.683 1.877 3.742 1.03 2.06 1.875 3.74 1.879 3.736.004-.004.642-1.02 1.418-2.261l1.41-2.256.965-.002.966-.004v-1.496l-1.384.002-1.385.002-.922 1.477c-.507.811-.923 1.474-.926 1.474-.002 0-.848-1.685-1.879-3.746z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgPulse;
